import styled from "styled-components";
import { FC } from "react";
import { ThreeDots } from "react-loader-spinner";
import { useAppDispatch, useAppSelector } from "../../store";
import defaultAvatar from "../../assets/default_avatar.png";
import BotIcon from "../../assets/chat-bot.png";

interface IAnswerComponent {
  type: "user" | "bot";
  content: string;
  isReplying?: boolean;
  options?: any;
  isSidebarOpen?: boolean;
}

interface Option {
  id: number;
  text: string;
  type: string;
}

interface WrapperProps {
  type: "user" | "bot";
  isOpen: boolean;
}

const AnswerComponent: FC<IAnswerComponent> = ({
  type,
  content,
  isReplying = false,
  isSidebarOpen = false,
  options,
}) => {
  const { userExtendData } = useAppSelector((state) => state.authReducer);

  return (
    <Wrapper type={type} isOpen={isSidebarOpen}>
      {isReplying && (
        <>
          {/* <BotReplying /> */}
          <img
            style={{
              width: 40,
              height: 40,
              borderRadius: '20px'
            }}
            src={BotIcon}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: 'center',
              alignItems: 'flex-start',
              margin: "0 8px",
              gap: 8,
              flex: 1,
            }}
          >
            <WrapperContent>
              <ThreeDots
                visible={true}
                width="30px"
                height="16"
                color="#ffffff"
                radius="9"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </WrapperContent>
          </div>
        </>
      )}
      {!isReplying && (
        <>
          {type === "bot" ? (
            <>
              {/* <BotReplied /> */}
              <img
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '20px'
                }}
                src={BotIcon}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "0 8px",
                  gap: 8,
                  flex: 1,
                }}
              >
                <WrapperContent>
                  <Content>{content}</Content>
                </WrapperContent>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "0 8px",
                  gap: 8,
                  flex: 1,
                  alignItems: "flex-end",
                }}
              >
                <WrapperContent>
                  <Content>{content}</Content>
                </WrapperContent>
              </div>
              <img style={{ width: 40, height: 40, borderRadius: '50%', objectFit: 'cover' }} src={userExtendData?.avatarUrl || defaultAvatar} />
            </>
          )}
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div<WrapperProps>`
  display: inline-flex;
  /* width: ${props => props.type === "bot" && "80%"}; */
  width: 80%;
  align-self: ${props => props.type === "user" ? "flex-end" : "flex-start"};
  align-items: ${props => props.type === "user" ? "center" : "flex-start"};
  box-sizing: border-box;

  @media (max-width: 1300px) {
    width: ${props => props.type === "bot" && props.isOpen ? "100%" : ""};
  }

  @media (max-width: 768px) {
    width: fit-content;
  }
`;

const WrapperContent = styled.div`
  display: inline-flex;
  padding: 15px;
  border-radius: 16px;
  width: fit-content;
  overflow-wrap: anywhere;
  font-size: 16px;
  font-style: normal;
  border: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    padding: 10px;
    border-radius: 8px;
  }
`;

const Content = styled.p`
  margin: 0;
  color: #fff;
  font-size: 16px;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export default AnswerComponent;
